import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageDimensions: {
    defaultMessage: '{length}{unit} × {width}{unit} × {height}{unit}',
    description: 'Package dimensions display',
    id: 'e7XqRq',
  },
  unitInches: {
    defaultMessage: '"',
    description: 'Unit symbol for inches measurement',
    id: 'KP9oU/',
  },
  unitCentimeters: {
    defaultMessage: ' cm',
    description: 'Unit symbol for centimeters measurement',
    id: 'jp3R7Y',
  },
  packageWeight: {
    defaultMessage: 'Weight: {weight}',
    description: 'Package weight display',
    id: 'YaoiUf',
  },
  editPackage: {
    defaultMessage: 'Edit',
    description: 'Link text to expand package card and edit dimensions, weight, and insurance',
    id: 'AYSt6+',
  },
  savePackage: {
    defaultMessage: 'Save',
    description: 'Button text to save package configuration and collapse the edit form',
    id: '3IVfOc',
  },
  sizeLabel: {
    defaultMessage: 'Size',
    description: 'Label for package dimensions input fields',
    id: 'GmCP60',
  },
  weightLabel: {
    defaultMessage: 'Weight',
    description: 'Label for package weight input field',
    id: 'HbwqQK',
  },
  insuranceLabel: {
    defaultMessage: 'Insurance',
    description: 'Label for package insurance input field',
    id: '8fWWgh',
  },
  scaleLabel: {
    defaultMessage: 'Scale',
    description: 'Label for the button to read weight from scale',
    id: 'RGYNjy',
  },
});
